<template>
    <div class="PreachingTour">
        <div class="banner">
            <img class="banner"
                 src="@/assets/images/155756396222.png">
        </div>
        <div class="Crumbs">
            <breadcrumb />
        </div>
        <div class="bgcolor">
            <div class="main">
                <el-form :model="ruleForm"
                         :rules="rules"
                         ref="ruleForm"
                         label-width="0px"
                         class="demo-ruleForm">
                    <el-form-item class="search"
                                  label=""
                                  prop="region">
                        <span>城市</span><span class="bor">|</span>
                        <el-cascader placeholder="试试搜索"
                                     v-model="pagination.region"
                                     :props="props"
                                     :options="cityOptions"
                                     clearable
                                     filterable
                                     :change-on-select="false"></el-cascader>
                    </el-form-item>
                    <el-form-item class="entry"
                                  label=""
                                  prop="title">
                        <el-input maxlength="20"
                                  placeholder="请输入学校关键词"
                                  v-model="ruleForm.data.title">
                        </el-input>
                        <el-button type="success"
                                   @click="querySubmitForm()">学校搜索</el-button>

                    </el-form-item>
                </el-form>
            </div>
            <div class="Chart">
                <div class="chunk"
                     @click="changeUrl(item)"
                     v-for="(item ,index) in tableData">
                    <img :src="item.image">
                    <p class="school">{{item.title}}</p>
                    <p class="addes">宣讲时间：{{item.preachDate|formatDate }} <span>{{ item.preachTime}}</span></p>
                    <p class="addes">宣讲地点：{{item.address}}</p>
                    <!-- <div class="addes"><span>宣讲地点：</span>
                        <div class="text">
                            {{item.address}}</div>
                    </div> -->

                </div>
                <div v-show="tableDatashow"
                     class="imgmain">
                    <img src="@/assets/images/kongjiemian.png">
                    <!-- <p>没有查到任何信息</p> -->
                </div>
            </div>
            <div class="block">
                <el-pagination background=""
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page="ruleForm.pageIndex"
                               :page-sizes="[6, 15, 30]"
                               :page-size="ruleForm.pageSize"
                               layout="total,sizes,prev, pager, next, jumper"
                               :total="ruleForm.total">
                </el-pagination>
            </div>
        </div>

    </div>
</template>

<script>
import { listTitle } from "@/api/zpArticleApi";
import { queryprovinceandcity } from "@/api/jobPosition";
import breadcrumb from "@/components/breadcrumb";
export default {
    components: {
        breadcrumb
    },
    data() {
        return {
            ruleForm: {
                data: { city: "", province: "", title: "" },
                array: [],
                pageIndex: 1,
                pageSize: 6
            },
            tableDatashow: false,
            //总条数
            total: 0,
            sumdata: {},
            pagination: {
                region: []
            },
            props: {
                value: "code",
                label: "name",
                children: "child"
            },
            cityOptions: [],
            tableData: [],
            value: "",
            input2: "",
            rules: {
                positionType: [
                    {
                        required: false,
                        message: "请输入活动名称",
                        trigger: "blur"
                    },
                    {
                        min: 1,
                        max: 23,
                        message: "长度在 3 到 5 个字符",
                        trigger: "blur"
                    }
                ]
            },
            options: []
        };
    },
    created() {
        let searchRuleForm = sessionStorage.getItem("ruleForm");
        if (searchRuleForm) {
            this.ruleForm.data = JSON.parse(searchRuleForm).data;
            this.pagination.region = JSON.parse(searchRuleForm).array;
        }
    },
    mounted() {
        let pagenum = parseInt(sessionStorage.getItem("pageindex"));
        let pagenumber = parseInt(sessionStorage.getItem("pagesize"));
        this.ruleForm.pageIndex = pagenum;
        this.ruleForm.pageSize = pagenumber;
        this.getInit();
        this.getInitCityType();
    },
    methods: {
        getInitCityType() {
            queryprovinceandcity(-1).then(res => {
                this.cityOptions = res.data;
            });
        },
        //数据初始化
        getInit() {
            this.ruleForm.data.province = this.pagination.region[0];
            this.ruleForm.data.city = this.pagination.region[1];
            // this.sumdata.data = this.ruleForm;
            listTitle(this.ruleForm).then(res => {
                if (res.status === 2000) {
                    this.tableData = res.data.rows;
                    this.ruleForm.total = res.data.total;
                    // this.ruleForm.pageIndex = res.data.page;
                    if (this.tableData == undefined) {
                        this.tableDatashow = true;
                    } else {
                        this.tableDatashow = false;
                    }
                }
            });
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.ruleForm.pageSize = val;
            sessionStorage.setItem("pageindex", 1);
            sessionStorage.setItem("pagesize", val);
            this.getInit();
        },
        // handleSizeChange() {
        //     this.sumdata.pageSize = val;
        //     this.getInit();
        // },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.ruleForm.pageIndex = val;
            sessionStorage.setItem("pageindex", val);
            this.getInit();
        },
        querySubmitForm() {
            this.ruleForm.array = this.pagination.region;
            //ruleForm 放入 seesion
            sessionStorage.setItem("ruleForm", JSON.stringify(this.ruleForm));
            this.ruleForm.pageIndex = 1;
            sessionStorage.setItem("pageindex", 1);
            this.topath();
            this.getInit();
        },
        topath() {
            this.$router.push({
                path: this.$route.path,
                query: {
                    id: this.$route.query.id,
                    search: this.ruleForm.data.title
                }
            });
        },
        changeUrl(item) {
            this.$router.push({
                path: "/preachingDetails",
                query: {
                    id: this.$route.query.id,
                    contentid: item.id
                }
            });
        }
    }
};
</script>


<style scoped lang="scss">
.PreachingTour {
    .banner {
        width: 100%;
    }
    .imgmain {
        // width: 400px;
        img {
            width: 100%;
        }
        p {
            font-size: 14px;
            text-align: center;
            color: #888;
        }
    }
    .bgcolor {
        position: relative;
        padding-top: 30px;
        padding-bottom: 40px;
        width: 100%;
        background-color: #f5f6f7;
        .main {
            width: 1200px;
            margin: 0 auto;
            .search {
                float: left;
                width: 320px;
                height: 50px;
                background-color: #fff;
                .bor {
                    color: #ddd;
                }
                span {
                    font-size: 15px;
                    line-height: 50px;
                    color: #666;
                    margin-left: 26px;
                }
                .el-cascader,
                .el-select {
                    margin-left: 10px;
                    width: 220px;
                    // border: none;
                    // .el-input {
                    //     .el-input__inner {
                    //         border: none !important;
                    //     }
                    // }
                    /deep/ .el-input--suffix .el-input__inner {
                        border-radius: 0;
                        border: none;
                    }
                }
            }
            .entry {
                width: 820px;
                float: right;
                height: 50px;
                margin-bottom: 30px;
                background-color: #fff;
                /deep/ .el-input {
                    width: 720px;
                    height: 50px;
                    border: none;
                    .el-input__inner {
                        height: 50px;
                        border: none;
                    }
                }
                .el-button {
                    height: 50px;
                    font-size: 15px;
                    border-radius: 0;
                    background-color: #fabe00;
                    border: none;
                    color: #fff !important;
                }
            }
        }
        .Chart {
            clear: both;
            width: 1200px;
            margin: 0 auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: start;
            .chunk {
                cursor: pointer;
                margin: 15px 10px;
                width: 380px;
                height: 322px;
                background-color: #fff;
                img {
                    width: 100%;
                    height: 197px;
                }
                p {
                    margin: 0 20px;
                    color: #666;
                    font-size: 15px;
                }
                .school {
                    // width: 280px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    color: #000;
                    margin-top: 15px;
                    font-size: 18px;
                    font-weight: 600;
                }
                .addes {
                    margin-top: 15px;
                    span {
                        color: #666;
                        font-size: 16px;
                        margin-left: 12px;
                    }
                    .text {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        float: left;
                        width: 250px;
                        color: #666;
                        font-size: 16px;
                    }
                }
            }
        }
        .block {
            margin-top: 20px;
            .el-pagination {
                text-align: center;
                margin-top: 40px;
            }
            /deep/ .el-pagination.is-background .el-pager li {
                border-radius: 15px;
            }
            /deep/ .el-pagination.is-background .btn-prev,
            /deep/ .el-pagination.is-background .btn-next {
                border-radius: 15px;
            }
        }
    }
}
</style>
